<template>
  <div class="wow bounceInRight animated in_abt">
    <!-- title -->
    <in-title
      :titletxt="lange == 'ch' ? obj.inTitle1.ch : obj.inTitle1.en"
      colors="color:#06566c;"
      xiancolor="background-color:#7aa5b1;"
      zong="0"
    />

    <img class="in_i" src="@/assets/images/ina_ico_1.png" />
    <div class="in_abtCnt">
      <div class="in_abd">
        <div class="in_aleft">
          <img src="@/assets/images/in_ico_1.png" />
        </div>
        <div class="in_aright">
          <div class="in_argTitle">
            <span v-if="lange == 'ch'">{{ obj.text1.ch }}</span>
            <span v-else>{{ obj.text1.en }}</span>
          </div>
          <div class="in_argSubtitle">
            <span v-if="lange == 'ch'">{{ obj.text2.ch }}</span>
            <span v-else>{{ obj.text2.en }}</span>
          </div>
          <div class="in_argCot">
            {{ lange == "ch" ? obj.text3.ch : obj.text3.en }}
          </div>
          <router-link class="in_aMore" to="/aboutus" v-if="lange == 'ch'">{{
            obj.text4.ch
          }}</router-link>
          <router-link class="in_aMore" to="/aboutus" v-else>{{
            obj.text4.en
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InTitle from "./InTitle";
export default {
  name: "InAbout",
  components: { InTitle },
  computed: {},
  data() {
    return {
      obj: {},
      lange: this.$cookies.getCookie("language"),
    };
  },
  created() {
    this.obj = this.$store.state.indexText;
  },
  methods: {},
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.in_abtCnt {
  width: 62.5%;
  min-height: 35px;
  display: block;
  margin: 0 auto;
  position: relative;
}

/* about */
.in_abt {
  width: 100%;
  display: block;
  position: relative;
  margin: 60px 0;
}
.in_i {
  width: 36%;
  display: block;
  margin: 15px 0 15px 32%;
}
.in_abd {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.in_aleft {
  width: 42%;
  display: block;
  position: relative;
}
.in_aleft > img {
  width: 100%;
  display: block;
}

.in_aright {
  width: 54%;
  display: block;
}
.in_argTitle {
  width: 100%;
  display: block;
  font-size: 20px;
  color: #02182c;
  font-weight: bold;
  margin-top: 15px;
}
.in_argTitle > span {
  margin-left: 0px;
}
.in_argSubtitle {
  width: 100%;
  display: block;
  margin: 15px 0 25px 0;
}
.in_argSubtitle > span {
  display: inline-block;
  font-size: 16px;
  color: #b09461;
  padding: 5px 10px;
  border: 1px solid #b09461;
  clear: both;
}
.in_argCot {
  width: 100%;
  display: block;
  font-size: 14px;
  color: #666;
  line-height: 26px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  /*word-break: break-all;111*/
}
.in_aMore {
  display: inline-block;
  font-size: 14px;
  padding: 10px 38px;
  background-color: #b09461;
  color: #fff;
  border-radius: 6px;
  font-weight: bold;
  margin: 25px 0 0 0;
}
@media only screen and (max-width: 1440px) {
  .in_abtCnt {
    width: 90%;
  }
}
@media only screen and (max-width: 425px) {
  .in_abt {
    margin: 30px 0;
  }
  .in_abd {
    text-align: center;
  }
  .in_aleft {
    width: 100%;
    display: block;
    position: relative;
  }
  .in_aright {
    width: 100%;
    display: block;
  }
  .in_i {
    margin: 10px 32%;
  }
  .in_argTitle {
    font-size: 16px;
  }
  .in_argSubtitle {
    margin: 12px 0;
  }
  .in_argSubtitle > span {
    font-size: 14px;
  }
  .in_argCot {
    font-size: 12px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/component/InAbout.vue